import { render } from "./printers.vue?vue&type=template&id=b826f72a"
import script from "./printers.vue?vue&type=script&lang=js"
export * from "./printers.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__